import styled from 'styled-components';
import {
    MOBILE_BREAKPOINT,
    SELECTORS,
    TABLET_BREAKPOINT
} from '../../constants';

export const InformationSectionContainer = styled.section`
    ${SELECTORS} & {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: center;
        margin-bottom: 100px;
    }
`;

//Text section
export const InformationSectionTextContainer = styled.div`
    ${SELECTORS} & {
        width: 40%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            width: 60%;
        }
    }
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            width: 80%;
            margin: 25px auto 0 auto;
            order: 2;
            justify-content: center;
        }
    }
`;

export const InformationSectionDevicesSvgContainer = styled.div`
    ${SELECTORS} & {
        width: 100%;
        svg {
            width: 100%;
            margin: auto;
        }
        @media (max-width: ${TABLET_BREAKPOINT}) {
            display: none;
        }
    }
`;

export const InformationSectionTitle = styled.h1`
    ${SELECTORS} & {
        text-align: center;
        margin: 25px 0;
        font-size: 40px;
        line-height: 48px;
        span {
            font-size: 40px;
            line-height: 48px;
        }
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 32px;
            line-height: 38px;
            span {
                font-size: 32px;
                line-height: 38px;
            }
        }
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        ${SELECTORS} & {
            text-align: center;
        }
    }
`;

export const InformationSectionDescription = styled.p`
    ${SELECTORS} & {
        text-align: center;
        margin-bottom: 25px;
        font-size: 24px;
        line-height: 29px;
        width: 100%;
        a {
            font-size: 24px;
            line-height: 29px;
            color: white;
            text-decoration: underline;
        }
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 16px;
            line-height: 19px;
            a {
                font-size: 16px;
                line-height: 19px;
            }
        }
    }

`;

export const DiscoverButtonContainer = styled.div`
    ${SELECTORS} & {
        width: 100%;
    }
`;

export const ViewAllGamesContainer = styled.div`
    ${SELECTORS} & {
        margin: 25px 0 auto 0;
        width: 100%;
        height: fit-content;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: center;

        &:hover {
            opacity: 0.6;
        }

        svg {
            margin-left: 5px;
            height: auto;
        }
    }
`;

export const ViewAllGamesText = styled.a`
    ${SELECTORS} & {
        text-decoration: underline;
        color: white;
        font-size: 16px;
        line-height: 19px;
        
        &:hover {
            color: white;
        }
    }
`;
